import { KaiError } from './errors'

export type ApiError = KaiError & {
  status: number
  data: any
}
export type ClientError = ApiError
export type ServerError = ApiError

export const createClientError = (
  status: number,
  message: string,
  data: any
): ClientError => ({
  status,
  message,
  data
})

export const createServerError = (
  status: number,
  message: string,
  data: any
): ClientError => ({
  status,
  message,
  data
})
